<div class="card"
      [ngClass]="{'card-selected': selected}">
      <div class="header-card">
        <ng-content select="[header]"></ng-content>
      </div>
      <div class="content">
        <ng-content></ng-content>
      </div>
</div>
